import { render, staticRenderFns } from "./SingleNotice.vue?vue&type=template&id=4e1a5b4d&scoped=true&"
import script from "./SingleNotice.vue?vue&type=script&lang=js&"
export * from "./SingleNotice.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotice.vue?vue&type=style&index=0&id=4e1a5b4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a5b4d",
  null
  
)

export default component.exports